module.exports = __webpack_public_path__ + "static/media/cl_tagline_red.2f887ea4.svg";